define('viewModels/privileged/qm/policies/editors/DirectionEditorView',[
    'lib/lodash4',
    'lib/knockout',
    'viewModels/privileged/qm/policies/editors/CheckedListEditorView',
    'services/qualityManagementService'
], function (_, ko, CheckedListEditorView, qualityManagementService) {
    'use strict';

    /**
     * The DirectionEditorView class.
     * @class
     */
    var DirectionEditorView = CheckedListEditorView.extend(function (directionsObservable) {
        var self = this;

        self.allDirectionsList = ko.observableArray();
        self.selectedDirectionsList = ko.observableArray();

        self.directions = directionsObservable.extend({deepComparer: true, minItems: {params: 1, message: "directionsEditorView.noDirectionsSelected"}});

        self.getDisplayString = function (item) {
            return item.display;
        };

        qualityManagementService.getConversationDirections().then(function (conversationDirections) {
            self.allDirectionsList(conversationDirections());

            self.selectedDirectionsList(_.reduce(self.directions(), function (directions, directionKey) {
                var direction = _.find(self.allDirectionsList(), function (directionItem) {
                    return directionItem.id == ko.unwrap(directionKey);
                });

                if (direction) {
                    directions.push(direction);
                }
                return directions;
            }, []));

            self.computed(function() {
                var unwrapped = ko.unwrap(self.selectedItemsList);
                self.directions(_.map(unwrapped, "id"));
            });

            self.init(self.allDirectionsList(), self.selectedDirectionsList());
        });
    });

    return DirectionEditorView;
});

